export enum PRODUCTS_SDK_METHODS {
    GET_PRODUCTS_SHARED_STATE_KIT = "getProductsSharedStateKit",
}
